import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import styles from '../styles/Portfolio.module.css';
import portfolioHero from '../images/hero/portfolio-hero.webp';
import portfolioBar from '../images/hero/Bar.webp';
import portfolioCatering from '../images/portfolio/catering.webp';
import portfolioBread from '../images/portfolio/artisan-bread.webp';
import portfolioEvents from '../images/portfolio/events.webp';

const projectImages = [
  {
    key: 'bar',
    image: portfolioBar,
  },
  {
    key: 'catering',
    image: portfolioCatering,
    reverse: true,
  },
  {
    key: 'bread',
    image: portfolioBread,
  },
  {
    key: 'events',
    image: portfolioEvents,
    reverse: true,
  },
];

const Portfolio = () => {
  const { t } = useI18n();

  return (
    <main className={styles.page}>
      <header
        className={styles.banner}
        style={{ backgroundImage: `url(${portfolioHero})` }}
      >
        <h1>{t('pages.portfolio.title')}</h1>
      </header>

      <section className={styles.intro}>
        <p className={styles.eyebrow}>{t('pages.portfolio.eyebrow')}</p>
        <h2>{t('pages.portfolio.introHeading')}</h2>
        <p>{t('pages.portfolio.introText')}</p>
      </section>

      <div className={styles.projectList}>
        {projectImages.map(project => {
          const copy = `pages.portfolio.projects.${project.key}`;

          return (
            <article
              className={`${styles.project} ${project.reverse ? styles.reverse : ''}`}
              key={project.key}
            >
              <div className={styles.projectCopy}>
                <p className={styles.sectionLabel}>{t(`${copy}.label`)}</p>
                <h2>{t(`${copy}.title`)}</h2>
                <p>{t(`${copy}.text`)}</p>
              </div>
              <div className={styles.projectImage}>
                <img
                  src={project.image}
                  alt={t(`${copy}.imageAlt`)}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </article>
          );
        })}
      </div>
    </main>
  );
};

export default Portfolio;
